"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const isSimpleObject_1 = __importDefault(require("./isSimpleObject"));
const deepFilter = (object, func) => ((0, isSimpleObject_1.default)(object) ? Object.fromEntries(Object.entries(object).reduce((result, [key, value]) => {
    if ((0, isSimpleObject_1.default)(value)) {
        const filtered = deepFilter(value, func);
        return Object.keys(filtered).length > 0
            ? [...result, [key, filtered]]
            : result;
    }
    return [...result, ...(func(value) ? [[key, value]] : [])];
}, [])) : object);
exports.default = deepFilter;
